// extracted by mini-css-extract-plugin
module.exports = {"itemLabel":"invoicesimulation_itemLabel__CWZyP"};